export { default } from '@/features/dashboard/invoices/pages/Desktop'
